var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('label',[_c('input',{style:({width: _vm.calculateWidth + '%'}),attrs:{"type":_vm.inputType,"placeholder":_vm.placeholderText},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }